import L from 'leaflet';
import ReactDOM from 'react-dom';
import {map, PopupBehavior, SetLastOpenedPopup, GetUserPermissions, GetUserName, isMobileVersion} from './Main.js'
import {DrawDecorativeMarker} from './MarkerManager'
import {EditPPSetup, GetLastLinkedObj} from './PPManager';
import { SearchComponent } from "../react-components/search/SearchComponent";

var lastMyDiv = null;

var selectedPoleId;

export function AddDecorativeSetup(latlng, popup, currentTime, typecode) {
    //var poleId;
    var buttonType= (typecode == 10) ? "Sergek-btn" : "banner-btn";
    document.getElementById(`${buttonType}${currentTime}`).addEventListener('click', function () {
        var sergekPopupDiv = document.createElement('div');
		sergekPopupDiv.id = 'sergekPopup';
        
		document.body.appendChild(sergekPopupDiv);

		document.getElementById('sergekPopup').innerHTML = '<div id="divMainObjectNumber"></div><br><div id="divButtons"><div>'			

    var linkedtp = GetLastLinkedObj();
    var parentName;
    const searchLinkPP = `${process.env.REACT_APP_BASE_URL}/api/objects_list/searchPP?name=`;
    const container = document.getElementById('divMainObjectNumber');

    function handeleClickFindPP(id, name, lat, lng) {
      linkedtp = name;
      
      const innerContainer = document.getElementById('mainObjectNumber');
      const labelElement = document.getElementById('mainObjectNumberLabel');
      labelElement.textContent = 'Номер опоры: ';

      const divButtons = document.getElementById('divButtons');
      divButtons.innerHTML = '<button id="backSergek">Назад</button><button id="saveSergek">Сохранить</button><span class="error-text" id="errorText"></span>';

      const searchLinkPole = `${process.env.REACT_APP_BASE_URL}/api/objects_list/getAllPolesByName?linkedtp=${linkedtp}&name=`;
      function handeleClickFindPole(id, name, lat, lng) {
        console.log("id pole " + id);
        parentName = name;
        selectedPoleId = id;
      }
      var delayInMilliseconds = 100; //1 second

      setTimeout(function() {
        ReactDOM.unmountComponentAtNode(innerContainer);
          ReactDOM.render(<SearchComponent
          handeleClickFind={handeleClickFindPole}
          link={searchLinkPole}
          home={false}
          propsValue=""
        ></SearchComponent>, innerContainer);
      }, delayInMilliseconds);

      SergekButtonSetup(sergekPopup, typecode, labelElement, divButtons, innerContainer, handeleClickFindPP, searchLinkPP, linkedtp, latlng, parentName, null);

    }

    
    ReactDOM.render(<div className="div__flex" ><label for="mainObjectNumber" id="mainObjectNumberLabel">Номер связанного ПП: </label><div id="mainObjectNumber"><SearchComponent
      handeleClickFind={handeleClickFindPP}
      link={searchLinkPP}
      home={false}
      propsValue={linkedtp}
    ></SearchComponent></div></div>, container);

        var sergekPopup = L.popup()
        .setContent(sergekPopupDiv)
        .setLatLng(latlng)
        .openOn(map);
        sergekPopupDiv.parentElement.style.width = "300px";

    });
  }
  
export function EditDecorativeSetup(decorativeId, latlng, marker) {
  fetch(`${process.env.REACT_APP_BASE_URL}/api/objects_list/get_object_by_id/${decorativeId}`)
    .then(response => response.json())
    .then(data => {
        data.forEach(obj => { 
          var sergekPopupDiv = document.createElement('div');
          sergekPopupDiv.id = 'sergekPopup';
              
          document.body.appendChild(sergekPopupDiv);
      
          document.getElementById('sergekPopup').innerHTML = '<div id="divMainObjectNumber"></div><br><div id="divButtons"><button id="backSergek">Назад</button><button id="saveSergek">Сохранить</button><span class="error-text" id="errorText"></span><div>'			
      
          
          var linkedtp = obj.linkedtp;
          var parentName = obj.parentname;
          selectedPoleId = obj.parent;
          const searchLinkPole = `${process.env.REACT_APP_BASE_URL}/api/objects_list/getAllPolesByName?linkedtp=${obj.linkedtp}&name=`;
          const searchLinkPP = `${process.env.REACT_APP_BASE_URL}/api/objects_list/searchPP?name=`;
          const container = document.getElementById('divMainObjectNumber');

          const divButtons = document.getElementById('divButtons');

          function handeleClickFindPole(id, name, lat, lng) {
            console.log("find " + name);
            parentName = name;
            selectedPoleId = id;
            SergekButtonSetup(sergekPopup, obj.typecode, labelElement, divButtons, innerContainer, handeleClickFindPP, searchLinkPP, linkedtp, latlng, decorativeId, parentName, marker);
          }

          function handeleClickFindPP(id, name, lat, lng) {
            linkedtp = name;
            
            
            labelElement.textContent = 'Номер опоры: ';
      
            
            divButtons.innerHTML = '<button id="backSergek">Назад</button><button id="saveSergek">Сохранить</button><span class="error-text" id="errorText"></span>';
      
            const searchLinkPole = `${process.env.REACT_APP_BASE_URL}/api/objects_list/getAllPolesByName?linkedtp=${linkedtp}&name=`;

            var delayInMilliseconds = 100; //1 second
      
            setTimeout(function() {
              ReactDOM.unmountComponentAtNode(innerContainer);
                ReactDOM.render(<SearchComponent
                handeleClickFind={handeleClickFindPole}
                link={searchLinkPole}
                home={false}
                propsValue=""
              ></SearchComponent>, innerContainer);
            }, delayInMilliseconds);
      
            SergekButtonSetup(sergekPopup, obj.typecode, labelElement, divButtons, innerContainer, handeleClickFindPP, searchLinkPP, linkedtp, latlng, decorativeId, parentName, marker);
          }
        
          ReactDOM.render(<div className="div__flex" ><label for="mainObjectNumber" id="mainObjectNumberLabel">Номер опоры: </label><div id="mainObjectNumber"><SearchComponent
            handeleClickFind={handeleClickFindPole}
            link={searchLinkPole}
            home={false}
            propsValue={obj.parentname}
          ></SearchComponent></div></div>, container);
      
              var sergekPopup = L.popup()
              .setContent(sergekPopupDiv)
              .setLatLng(latlng)
              .openOn(map);
              sergekPopupDiv.parentElement.style.width = "300px";     

              const labelElement = document.getElementById('mainObjectNumberLabel');
              const innerContainer = document.getElementById('mainObjectNumber');
              SergekButtonSetup(sergekPopup, obj.typecode, labelElement, divButtons, innerContainer, handeleClickFindPP, searchLinkPP, linkedtp, latlng, decorativeId, parentName, marker);
        })
    });
}

function SergekButtonSetup(popup, typecode, labelElement, divButtons, innerContainer, handeleClickFindPP, searchLinkPP, linkedtp, latlng, id, parentName, circle) {
  document.getElementById('backSergek').addEventListener('click', function () {
    this.disabled = true;
  labelElement.textContent = 'Номер связанного ПП: ';

    
    var delayInMilliseconds = 100; //1 second
    setTimeout(function() {
      ReactDOM.unmountComponentAtNode(innerContainer);
      divButtons.innerHTML = '';
      selectedPoleId = null;
        ReactDOM.render(<SearchComponent
        handeleClickFind={handeleClickFindPP}
        link={searchLinkPP}
        home={false}
        propsValue=""
      ></SearchComponent>, innerContainer);
    }, delayInMilliseconds); 
  });

  document.getElementById('saveSergek').addEventListener('click', function () {
    this.disabled = true;
    if (!selectedPoleId) {
      document.getElementById("errorText").textContent = "Не выбрана опора";
      this.disabled = false;
      return;
    }
    
    if (id) {
      console.log("linkedtp " + linkedtp + " id = " + id);
      EditSergek(linkedtp, id, typecode, this, circle, latlng, parentName);
    }
    else {
      AddSergek(linkedtp, latlng, typecode, this, parentName);
    }
    map.closePopup(popup); 
  });
}

function AddSergek(linkedtp, latlng, typecode, button, parentName) {
  const encodedLinkedtp = encodeURIComponent(linkedtp);
    fetch(`${process.env.REACT_APP_BASE_URL}/api/objects_list/getPPbyName/${encodedLinkedtp}`)
    .then(response => response.json())
    .then(data => {
      if (data.length < 1) {
        document.getElementById("errorText").textContent = "Данного ПП нет в списке объектов";
        button.disabled = false;
      } else {
        var objectId;
        var objectName = (typecode == 10) ? "Камера Сергек" : "Рекламный баннер";
        fetch(`${process.env.REACT_APP_BASE_URL}/api/objects_list/insertObject`, {
          //fetch(`${process.env.REACT_APP_BASE_URL}/objects_list`, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({name: objectName, linkedtp: linkedtp, typecode: typecode, lat: latlng.lat, lng: latlng.lng, textPosition: 0, parent: selectedPoleId})
              })
          .then(response => {
              response.json().then(response => {
                  objectId = response.id;
                  var circle = DrawDecorativeMarker(latlng, typecode, objectId, linkedtp, null).addTo(map);
                  DecorativePopupSetup(typecode, circle, objectId, latlng, parentName, linkedtp);
                  PopupBehavior(circle, objectId, latlng, '', typecode, '');

                }) 
          })
          .catch(error => {
                  console.error('Ошибка добавления опоры: ', error);
          });
      }
      
    });
}

function EditSergek(linkedtp, id, typecode, button, circle, latlng, parentName) {
  var objectName = (typecode == 10) ? "Камера Сергек" : "Рекламный баннер";
  const encodedLinkedtp = encodeURIComponent(linkedtp);
  fetch(`${process.env.REACT_APP_BASE_URL}/api/objects_list/getPPbyName/${encodedLinkedtp}`)
    .then(response => response.json())
    .then(data => {
      if (data.length < 1) {
        document.getElementById("errorText").textContent = "Данного ПП нет в списке объектов";
        button.disabled = false;
      } else {
  fetch(`${process.env.REACT_APP_BASE_URL}/api/objects_list/updateObject`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({name: objectName, linkedtp: linkedtp, typecode: typecode, textPosition: 0, parent: selectedPoleId, id: id})
        })
    .then(response => {
      console.log("PopupBehavior id = " + id + " " + (circle === null));
      circle = DrawDecorativeMarker(latlng, typecode, id, linkedtp, circle).addTo(map);
      DecorativePopupSetup(typecode, circle, id, latlng, parentName, linkedtp);
      PopupBehavior(circle, id, latlng, '', typecode, '');
    })
    .catch(error => {
            console.error('Ошибка добавления опоры: ', error);
    });
  }});
}

  export function DecorativePopupSetup(typecode, circle, objectId, latlng, parentName, linkedtp) {
    
    var isEditable = false;
  var departmentAccessArray = GetUserPermissions();

    const entry = departmentAccessArray.find(entry => {
      if (linkedtp === null) {
          return entry.startsWith("00=");
      } else {
          return entry.startsWith(linkedtp.substring(0, 2) + "=") || entry.startsWith("00=");
      }
  });
    if (entry) {
      // Если строка найдена, получаем значение
      const value = entry.split("=")[1];
      switch (value) {
        case '1':
        case '2':
          isEditable = true;
          console.log("Значение ", isEditable, entry.split("=")[1]);
          break;
        case '3':
          isEditable = false;
          break;
      }
    }
  

    var objectName = (typecode == 10) ? "Камера Сергек" : "Рекламный баннер";
          var editButtons = `<button id="editObject${objectId}" class="simple_button">Редактировать</button><button id="deleteObject${objectId}" class="simple_button">Удалить</button>`;

          if (GetUserName() === 'azhalpakov' || isMobileVersion || !isEditable) {
            editButtons = `<button id="editObject${objectId}" class="simple_button" style="display: none;">Редактировать</button><button id="deleteObject${objectId}" class="simple_button" style="display: none;">Удалить</button>`;
          }
          // Привяжите событие popupopen к маркеру
        circle.on('click', function () {
            if (lastMyDiv) {
              lastMyDiv.remove();
            }
          
          const latlng = circle.getLatLng(); 
          var popupContent = `<b>${objectName} от Опоры ${parentName} ШУНО: ${linkedtp}</b><br>Координаты: ${latlng.lat}, ${latlng.lng}<br>${editButtons}`;
          var myDiv = document.createElement('div');
          myDiv.innerHTML = popupContent;
          var popup =  L.popup()
                        .setContent(myDiv)
                        .setLatLng(latlng)
                        .openOn(map);     
          SetLastOpenedPopup(popup); 
          lastMyDiv = myDiv;   
       });
  }